import * as brewer from './brewer'
import * as office from './office'
import * as tableau from './tableau'

export default {
  brewer: brewer.default,
  office: office.default,
  tableau: tableau.default,
}
